export function CalculateTotalRepairs(item) {
  item.labour_total_cost = item.labour_hours * item.labour_hour_rate;
  //
  // Get used materials total
  var used_materials_total = 0;
  if (item.used_materials) {
    for (var i = 0; i < item.used_materials.length; i++) {
      used_materials_total += parseFloat(item.used_materials[i].total_cost);
    }
  }
  // Compute Total Cost of Repair GST = (item.labour_total_cost + used_materials_total) * 0.1
  item.total_cost_of_repair_gst =
    (item.labour_total_cost + used_materials_total) * 0.1;
  // Compute Total Cost of Repair (inc GST) = (item.labour_total_cost + used_materials_total) + item.total_cost_of_repair_gst
  item.total_cost_of_repair_inc_gst =
    item.labour_total_cost +
    used_materials_total +
    item.total_cost_of_repair_gst;
  item.total_cost_of_repair_inc_gst = item.total_cost_of_repair_inc_gst.toFixed(
    2
  );
  // Compute Amount To Bill = item.total_cost_of_repair_inc_gst + Adjustment To Bill
  if (!item.amount_adjustment) {
    item.amount_adjustment = 0;
  }
  item.amount =
    parseFloat(item.total_cost_of_repair_inc_gst) +
    parseFloat(item.amount_adjustment);
  item.total_cost_of_repair_gst = item.total_cost_of_repair_gst.toFixed(2);
  item.labour_total_cost = item.labour_total_cost.toFixed(2);
  item.amount = item.amount.toFixed(2);
}
